import { useCallback } from "react";
import type { JobPollingState } from "@src/services/state/layoutReducer";
import {
  removeActiveJobAction,
  resetJobSyncFlagAction,
  trackActiveJobAction,
  triggerJobSync,
  updateActiveJobAction,
} from "@src/services/state/layoutReducer";
import type { RootState } from "@src/services/state/store";
import { useDispatch, useSelector } from "react-redux";

export const useJobPolling = () => {
  const dispatch = useDispatch();
  const activeJobs = useSelector((state: RootState) => state.layout.activeJobs);
  const shouldSyncJobs = useSelector((state: RootState) => state.layout.shouldSyncJobs);

  const trackActiveJob = useCallback(
    (params: {
      jobId: number;
      jobType: JobPollingState["jobType"];
      entityType?: JobPollingState["entityType"];
      metadata?: JobPollingState["metadata"];
    }) => {
      dispatch(trackActiveJobAction(params));
    },
    [dispatch],
  );

  const updateActiveJob = useCallback(
    (params: { jobId: number; status: JobPollingState["status"]; entityId?: number }) => {
      dispatch(updateActiveJobAction(params));
    },
    [dispatch],
  );

  const untrackActiveJob = useCallback(
    (jobId: number) => {
      dispatch(removeActiveJobAction(jobId));
    },
    [dispatch],
  );

  const syncActiveJobs = useCallback(() => {
    dispatch(triggerJobSync());
  }, [dispatch]);

  const resetJobSyncFlag = useCallback(() => {
    dispatch(resetJobSyncFlagAction());
  }, [dispatch]);

  return {
    activeJobs,
    shouldSyncJobs,
    trackActiveJob,
    updateActiveJob,
    untrackActiveJob,
    syncActiveJobs,
    resetJobSyncFlag,
  };
};
